import request from '@/utils/request'

export function getRate() {
  const url = `${process.env.VUE_APP_CONTROLLER_API}/exchange_rate.yy.php`
  return request({
    url: url,
    method: 'get'
  })
}
